import { render, staticRenderFns } from "./DashResaler.vue?vue&type=template&id=6612cc35&"
import script from "./DashResaler.vue?vue&type=script&lang=js&"
export * from "./DashResaler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports